import React from "react";
import { MessageSquare, Bot, Database, Puzzle } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { cn } from "../lib/utils";
import { Link, useRouter } from "@tanstack/react-router";

interface SidebarProps {
  className?: string;
}

const navigationItems = [
  // {
  //   title: "Dashboard",
  //   icon: LayoutDashboard,
  //   href: "/",
  // },
  // {
  //   title: "Test Suites",
  //   icon: TestTube,
  //   href: "/test-suites",
  // },
  {
    title: "AI Agents",
    icon: Bot,
    href: "/ai-agents",
  },
  {
    title: "Data Sources",
    icon: Database,
    href: "/data-sources",
  },
  // {
  //   title: "Integrations",
  //   icon: Puzzle,
  //   href: "/integrations",
  // },
];

export const Sidebar: React.FC<SidebarProps> = ({ className }) => {
  const router = useRouter();
  const currentPath = router.state.location.pathname;

  return (
    <div
      className={cn(
        "flex flex-col h-screen bg-gray-900 border-r border-gray-800 w-64",
        className,
      )}
    >
      {/* Logo/Brand */}
      <div className="flex items-center justify-center h-19 px-6 py-4 border-b border-gray-800">
        <img src="/rippletide.svg" alt="Rippletide" />
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        <div className="space-y-1">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPath === item.href;
            return (
              <Link
                key={item.title}
                to={item.href}
                className={cn(
                  "flex items-center w-full px-3 py-2 text-sm font-medium rounded-md transition-all duration-200",
                  isActive
                    ? "bg-pink-400/20 text-pink-400 border border-pink-600/30 shadow-sm"
                    : "text-gray-300 hover:text-gray-100 hover:bg-gray-800/50 border border-transparent",
                )}
              >
                <Icon
                  className={cn(
                    "mr-3 h-4 w-4",
                    isActive ? "text-pink-400" : "text-gray-400",
                  )}
                />
                {item.title}
              </Link>
            );
          })}
        </div>
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-gray-800 bg-gray-900/50">
        <div className="flex items-center space-x-3">
          <Avatar className="h-8 w-8 ring-2 ring-gray-700">
            <AvatarImage src="" />
            <AvatarFallback className="bg-gray-700 text-gray-300 text-xs font-medium">
              AM
            </AvatarFallback>
          </Avatar>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-100 truncate">
              Andrea Mouraud
            </p>
            <p className="text-xs text-gray-400 truncate">
              andrea@rippletide.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
